import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { TableSelectedPage } from '@/types/Base';

export const useStateStore = defineStore('state', () => {
  const tableSelectedPage = ref<TableSelectedPage[]>([]);

  function setTableSelectedPage(tableId: string, page: number, itemsPerPage: number) {
    const tableIndex = tableSelectedPage.value.findIndex((x) => x.tableId === tableId);
    if (tableIndex !== -1) {
      tableSelectedPage.value[tableIndex].page = page;
      tableSelectedPage.value[tableIndex].itemsPerPage = itemsPerPage;
    } else {
      tableSelectedPage.value.push({ tableId, page, itemsPerPage });
    }
  }

  function getTableSelectedPage(
    tableId: string
  ): { page: number; itemsPerPage: number } | undefined {
    const table = tableSelectedPage.value.find((x) => x.tableId === tableId);

    return table ? { page: table.page, itemsPerPage: table.itemsPerPage } : undefined;
  }

  function removeTableSelectedPage(tableId: string) {
    const tableIndex = tableSelectedPage.value.findIndex((x) => x.tableId === tableId);

    if (tableIndex !== -1) {
      tableSelectedPage.value.splice(tableIndex, 1);
    }
  }
  function clearTableSelectedPage() {
    tableSelectedPage.value = [];
  }

  return {
    setTableSelectedPage,
    getTableSelectedPage,
    removeTableSelectedPage,
    clearTableSelectedPage,
  };
});
